/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Injectable } from '@angular/core';
import { OrganisationsApiService } from '../http';
import { UserService } from '../../../../core/services';

@Injectable()
export class OrganisationResolvers {
    constructor(
        private userService: UserService,
        private organisationsApiService: OrganisationsApiService
    ) {
    }

    public resolve() {
        const userDetails = this.userService.user;

        return this.organisationsApiService.get(userDetails.organisationId);
    }
}
